import { PropsWithChildren } from 'react';

import { typography, SearchInput } from '@ui';

import * as css from './SwingFilter.css';

type SwingFilterProps = {
    value: string;
    onChange: (value: string) => void;
    label?: string;
};

export const SwingFilter = ({ value, onChange, label }: SwingFilterProps) => {
    return (
        <div className={css.filter}>
            {label && (
                <p
                    className={typography({
                        variant: 'h4',
                    })}
                >
                    {label}
                </p>
            )}
            <div className={css.fields}>
                <SearchInput value={value} onChange={onChange} />
                {/* TODO: Add club filter
                 <button className={css.clubButton}>
                    <ClubIcon />
                    Club
                </button> */}
            </div>
        </div>
    );
};

type SwingFilterBoxProps = PropsWithChildren<{
    title?: string;
    variant?: css.FilterBoxVariants['variant'];
}>;

export const SwingFilterBox = ({ children, title, variant }: SwingFilterBoxProps) => {
    return (
        <div className={css.filterBox({ variant })}>
            {title && (
                <h3
                    className={typography({
                        variant: 'h2',
                    })}
                >
                    {title}
                </h3>
            )}
            {children}
        </div>
    );
};

type SwingFilterFooterProps = { swingCount: number };

export const SwingFilterFooter = ({ swingCount }: SwingFilterFooterProps) => {
    return (
        <div className={css.footer}>
            <p className={css.paragraph}>{swingCount} swings</p>
            <p className={css.pill}>All clubs</p>
        </div>
    );
};
